module.exports = __webpack_public_path__ + "img/terence-taylor.1dc3d214.png";